<template>
<router-view />
</template>

<script>
export default {
  name: 'DataManagementReportStatistical',
  routeInfo: {
    label: '报表统计',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/02Normal/index.vue